import { render, staticRenderFns } from "./ContractorsActions.vue?vue&type=template&id=0c10e1b8&scoped=true&"
import script from "./ContractorsActions.vue?vue&type=script&lang=js&"
export * from "./ContractorsActions.vue?vue&type=script&lang=js&"
import style0 from "./ContractorsActions.vue?vue&type=style&index=0&id=0c10e1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c10e1b8",
  null
  
)

export default component.exports